import React, { useEffect } from "react";
import Hero from "./Hero";
import Features from "./Features";
import Tutorial from "./Tutorial";
import Pricing from "./Pricing";
import Contact from "./Contact";

const Home = () => {
  
    useEffect(() => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("active");
              } else {
                entry.target.classList.remove("active");
              }
            });
          },
          { threshold: 0.2 }
        );
    
        const elementsToAnimate = document.querySelectorAll(".animate");
        elementsToAnimate.forEach((el) => observer.observe(el));
    
        return () => observer.disconnect();
      }, []);


  return (
    <div>
      <section id="home">
        <Hero />
      </section>
      <section id="features">
        <Features />
      </section>
      <section id="tutorial">
        <Tutorial />
      </section>
      <section id="pricing">
        <Pricing />
      </section>
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
};

export default Home;
